export type MetadataKey = `metadata.${string}`;

export const COMPARATORS = [
  "EQUALS",
  "NOT_EQUALS",
  "CONTAINS",
  "NOT_CONTAINS",
  "GREATER_THAN",
  "LESS_THAN",
  "GREATER_THAN_OR_EQUAL",
  "LESS_THAN_OR_EQUAL",
  "IS_NULL",
  "IS_NOT_NULL",
  "BEGINS_WITH",
  "EXISTS",
  "NOT_EXISTS",
  "LIKE",
  "NOT_LIKE",
] as const;

export type Comparator = (typeof COMPARATORS)[number];

export function isComparator(value: string): value is Comparator {
  return (COMPARATORS as unknown as string[]).includes(value);
}

export type ConditionsOperator = "AND" | "OR" | "NOT";

export type SortDirection = "ASC" | "DESC";

// These are the allowed searchable fields in the dataset table. We can add more as needed
export type DatasetField =
  | "dataset_id"
  | "created"
  | "created_by"
  | "metadata"
  | "modified"
  | "modified_by"
  | "tags"
  | MetadataKey;

export type ActionField =
  "name" | "created" | "description" | "data_source_id" | "last_status"; // etc. Add more as needed

export type InvocationField =
  | "data_source_id"
  | "data_source_type"
  | "last_status"
  | "provenance.action.name"
  | "provenance.action.org_id"
  | "provenance.action.digest"
  | "provenance.source.source_id"
  | "provenance.source.source_type";

export type SimpleCondition = {
  field: string; // etc. Add more as needed. E.g. TriggerField, InvocationField, etc.
  comparator: Comparator;
  value: boolean | number | string;
};

export interface ConditionGroup {
  conditions: Array<Condition | ConditionGroup>;
  operator: ConditionsOperator;
}

export type Condition = SimpleCondition | ConditionGroup;

export type FromToken = string | null;

export interface SearchQueryBody {
  condition?: Condition;
  limit?: number;
  /**
   * Maximum number of results to return across all pages. Distinct from `limit`,
   * which is the per-page size. Only honored for targets queryable via roboto search.
   *
   * When constructing a body to submit, omit it for the default uncapped behavior.
   * When reading a body parsed by the backend, an unset cap comes back as explicit `null`.
   */
  max_results?: number | null;
  after?: FromToken;
  sort_by?: string | null;
  sort_direction?: SortDirection;
}
